export const AboutWordsCollected = () => (
  <div>
    <h5 className="mb-3">What an impressive collection!</h5>
    <p className="mb-4">
      Check out how many individual words your child has encountered in Word Tag
      so far.
    </p>
  </div>
);
